// src/components/course/WordCardSkeleton.js
import React from 'react';
import Skeleton from 'react-loading-skeleton';

const WordCardSkeleton = ({ showTranslation }) => {
  return (
    <div className="relative flex flex-col justify-between p-4 rounded-xl border-2 border-border border-t-4 bg-background-secondary/80">
      {/* --- Main Content --- */}
      <div className="flex flex-col items-center justify-center flex-grow w-full py-2">
        <Skeleton width={100} height={30} />

        {/* MODIFIED: Conditionally render translation skeleton with correct margin */}
        {showTranslation && (
          <div className="mt-1">
            {' '}
            {/* Corrected from mt-2 to mt-1 */}
            <Skeleton width={80} height={18} />
          </div>
        )}
      </div>

      {/* --- Footer --- */}
      <div className="flex justify-center items-center pt-3 border-t border-border min-h-[34px] gap-2">
        {' '}
        {/* Corrected from pt-2 to pt-3 */}
        <Skeleton width={50} height={24} borderRadius={999} />
      </div>
    </div>
  );
};

export default WordCardSkeleton;
